var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainWrapper-innerContent"},[_c('div',{staticClass:"mainWrapper-leftContent mainWrapper-leftContent--fullWidth"},[_c('BreadCrumb',{attrs:{"breadcrumbList":_vm.breadcrumbs,"normal":""}}),_c('PublicArticle',{attrs:{"staticData":_vm.data}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }